const data = {
  "components": [
    {
      "staticURL": {
        "searchURL": "https://qa2.gehealthcare.cn/search"
      }
    },
    {
      "analyticsData": {
        "analyticsScriptPath": "https://assets.adobedtm.com/ea870d125975/0b7e4ee3552c/launch-21c894e5162a-staging.min.js",
        "pageName": "gehealthcare-cn|Home",
        "siteName": "gehealthcare-cn",
        "siteCountry": "cn",
        "siteLanguage": "zh",
        "siteSection": "HomePage Template - GE Healthcare"
      }
    },
    {
      "primarynavigation": {
        "logoutUrl": "/api/v1/logout",
        "employeeSignoutText": "登出",
        "countryIcon": "<svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C15.9941 3.58418 12.4158 0.00592331 8 0ZM8 15.0538C7 15.0538 5.91935 13.3548 5.46774 10.6882H10.5323C10.0806 13.3763 9 15.0538 8 15.0538ZM5.31183 9.6129C5.26344 9.10215 5.23656 8.56452 5.23656 8C5.23656 7.43548 5.23656 6.89785 5.31183 6.3871H10.6882C10.7366 6.89785 10.7634 7.43548 10.7634 8C10.7634 8.56452 10.7366 9.10215 10.6882 9.6129H5.31183ZM0.946237 8C0.948567 7.45703 1.01168 6.91602 1.13441 6.3871H4.36022C4.31183 6.92473 4.28495 7.46237 4.28495 8C4.28495 8.53763 4.31183 9.07527 4.36022 9.6129H1.13441C1.01168 9.08398 0.948567 8.54297 0.946237 8ZM8 0.946237C9 0.946237 10.0806 2.64516 10.5323 5.31183H5.46774C5.91935 2.62366 7 0.946237 8 0.946237ZM11.6237 6.3871H14.8495C15.101 7.44766 15.101 8.55234 14.8495 9.6129H11.6237C11.672 9.07527 11.6989 8.53763 11.6989 8C11.6989 7.46237 11.672 6.92473 11.6237 6.3871ZM14.5215 5.31183H11.4839C11.3044 3.85686 10.793 2.46257 9.98925 1.23656C12.0373 1.84197 13.7026 3.33942 14.5215 5.31183ZM6.01075 1.23656C5.20698 2.46257 4.69562 3.85686 4.51613 5.31183H1.47849C2.29736 3.33942 3.96273 1.84197 6.01075 1.23656ZM1.47849 10.6882H4.51613C4.69562 12.1431 5.20698 13.5374 6.01075 14.7634C3.96273 14.158 2.29736 12.6606 1.47849 10.6882ZM9.98925 14.7634C10.793 13.5374 11.3044 12.1431 11.4839 10.6882H14.5215C13.7026 12.6606 12.0373 14.158 9.98925 14.7634Z\" fill=\"#222222\"/>\n</svg>\n",
        "clearIcon": "<svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M14.8522 14.1403C14.899 14.1868 14.9362 14.2421 14.9616 14.303C14.9869 14.3639 15 14.4292 15 14.4952C15 14.5612 14.9869 14.6265 14.9616 14.6874C14.9362 14.7483 14.899 14.8036 14.8522 14.8501C14.8057 14.8969 14.7504 14.9341 14.6895 14.9595C14.6286 14.9849 14.5633 14.9979 14.4973 14.9979C14.4313 14.9979 14.366 14.9849 14.3051 14.9595C14.2442 14.9341 14.1889 14.8969 14.1425 14.8501L8 8.70225L1.85754 14.8501C1.81108 14.8969 1.7558 14.9341 1.6949 14.9595C1.634 14.9849 1.56867 14.9979 1.50269 14.9979C1.43671 14.9979 1.37139 14.9849 1.31048 14.9595C1.24958 14.9341 1.1943 14.8969 1.14784 14.8501C1.10099 14.8036 1.06381 14.7483 1.03844 14.6874C1.01306 14.6265 1 14.5612 1 14.4952C1 14.4292 1.01306 14.3639 1.03844 14.303C1.06381 14.2421 1.10099 14.1868 1.14784 14.1403L7.29529 7.9975L1.14784 1.85467C1.05373 1.76055 1.00085 1.6329 1.00085 1.49979C1.00085 1.43389 1.01383 1.36863 1.03905 1.30774C1.06427 1.24685 1.10124 1.19152 1.14784 1.14492C1.19444 1.09832 1.24976 1.06135 1.31065 1.03613C1.37153 1.01091 1.43679 0.997925 1.50269 0.997925C1.63579 0.997925 1.76343 1.0508 1.85754 1.14492L8 7.29275L14.1425 1.14492C14.2366 1.0508 14.3642 0.997925 14.4973 0.997925C14.6304 0.997925 14.758 1.0508 14.8522 1.14492C14.9463 1.23904 14.9991 1.36669 14.9991 1.49979C14.9991 1.6329 14.9463 1.76055 14.8522 1.85467L8.70471 7.9975L14.8522 14.1403Z\" fill=\"#6022A6\"/>\n</svg>\n",
        "secondaryCSCta": "取消",
        "primaryCSCta": "继续",
        "sfdcUserSignoutText": "登出",
        "shoppingCartTextLabel": "大车",
        "searchIcon": "<svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g clip-path=\"url(#clip0_1002_616)\">\n<path d=\"M1.58472e-05 6.02913C0.00181787 7.13171 0.306891 8.21259 0.881902 9.15367C1.45691 10.0947 2.27974 10.8598 3.26048 11.3653C4.24122 11.8708 5.34214 12.0972 6.44296 12.0198C7.54378 11.9424 8.60214 11.5643 9.5024 10.9266L14.3439 15.7589C14.5359 15.9232 14.7828 16.009 15.0353 15.9993C15.2878 15.9895 15.5274 15.8849 15.7061 15.7064C15.8848 15.5278 15.9895 15.2885 15.9993 15.0361C16.009 14.7838 15.9231 14.5371 15.7587 14.3453L10.9222 9.508C11.4729 8.73647 11.8334 7.84587 11.9743 6.90875C12.1151 5.97164 12.0324 5.01453 11.7328 4.11542C11.4333 3.2163 10.9254 2.40062 10.2505 1.73483C9.57554 1.06904 8.75275 0.57199 7.84911 0.284171C6.94548 -0.00364813 5.98657 -0.0740893 5.05052 0.0785875C4.11447 0.231264 3.22776 0.602739 2.46265 1.16274C1.69754 1.72275 1.07568 2.45544 0.647723 3.30111C0.21977 4.14678 -0.00216008 5.08151 1.58472e-05 6.02913ZM1.00344 6.02913C1.00344 5.0377 1.29768 4.06853 1.84897 3.24418C2.40025 2.41984 3.18382 1.77734 4.10057 1.39793C5.01733 1.01853 6.0261 0.919256 6.99932 1.11268C7.97254 1.30609 8.8665 1.78351 9.56816 2.48456C10.2698 3.18561 10.7476 4.0788 10.9412 5.05119C11.1348 6.02357 11.0355 7.03147 10.6557 7.94744C10.276 8.8634 9.63294 9.64629 8.80788 10.1971C7.98283 10.7479 7.01282 11.0419 6.02053 11.0419C5.36168 11.0419 4.70927 10.9122 4.10057 10.6603C3.49187 10.4084 2.93879 10.0392 2.47291 9.5737C1.53202 8.63362 1.00344 7.3586 1.00344 6.02913Z\" fill=\"#6022A6\"/>\n</g>\n<defs>\n<clipPath id=\"clip0_1002_616\">\n<rect width=\"16\" height=\"16\" fill=\"white\"/>\n</clipPath>\n</defs>\n</svg>\n",
        "searchText": "搜索",
        "downArrowIcon": "<svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M1.99928 4.38619C2.08671 4.38514 2.1734 4.40213 2.25377 4.43607C2.33414 4.47002 2.40642 4.52017 2.46594 4.58329L7.99928 10.0233L13.5326 4.58329C13.5925 4.52044 13.6648 4.47034 13.745 4.4361C13.8253 4.40186 13.9118 4.38419 13.9993 4.38419C14.0867 4.38419 14.1733 4.40186 14.2535 4.4361C14.3338 4.47034 14.4061 4.52044 14.4659 4.58329C14.5297 4.64227 14.5805 4.71352 14.6153 4.79262C14.65 4.87172 14.668 4.957 14.668 5.04319C14.668 5.12938 14.65 5.21466 14.6153 5.29377C14.5805 5.37287 14.5297 5.44411 14.4659 5.50309L8.46594 11.4161C8.40609 11.479 8.3338 11.5291 8.25354 11.5633C8.17327 11.5976 8.08674 11.6152 7.99928 11.6152C7.91181 11.6152 7.82528 11.5976 7.74502 11.5633C7.66475 11.5291 7.59246 11.479 7.53261 11.4161L1.53261 5.50309C1.46884 5.44411 1.41801 5.37287 1.38326 5.29377C1.34851 5.21466 1.33059 5.12938 1.33059 5.04319C1.33059 4.957 1.34851 4.87172 1.38326 4.79262C1.41801 4.71352 1.46884 4.64227 1.53261 4.58329C1.59214 4.52017 1.66441 4.47002 1.74478 4.43607C1.82515 4.40213 1.91184 4.38514 1.99928 4.38619Z\" fill=\"#6022A6\"/>\n</svg>\n",
        "changeCountryText": "更改国家/地区",
        "myAccountTextLabel": "账户",
        "logoReference": {
          "dmId": "DynamicMedia-1398730865-549b6848-0a15-4761-a32c-900e7a79a219-ce3350a6859d4e2fad0dd567b1d12822",
          "assetPath": "gehealthcarestage/logo-Light-GEHC-8",
          "assetName": "/images/gehealthcarestage/logo-Light-GEHC-8.png",
          "viewerPath": "https://s7d9.scene7.com/s7viewers/",
          "serverPath": "https://s7d9.scene7.com/is/image/"
        },
        "tickMarkIcon": "/content/dam/gehc/global/icons/default-icon/ico-tick-mark.svg",
        "leadGenUrl": "/about/contact-us",
        "isDisplaySearch": "true",
        "sfdcUserSignoutUrl": "/api/v1/logout",
        "signoutText": "Sign out",
        "cartUrl": "/zh-cn/cart",
        "sectionTitle": "更改国家/地区/语言",
        "upArrowIcon": "<svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M14.4996 11.7496C14.434 11.7504 14.369 11.7374 14.3087 11.7116C14.2484 11.6858 14.1942 11.6476 14.1496 11.5996L7.99957 5.45957L1.84957 11.5996C1.80468 11.6474 1.75046 11.6855 1.69026 11.7116C1.63006 11.7376 1.56516 11.7511 1.49957 11.7511C1.43397 11.7511 1.36907 11.7376 1.30887 11.7116C1.24867 11.6855 1.19446 11.6474 1.14957 11.5996C1.10173 11.5547 1.06361 11.5005 1.03755 11.4403C1.01149 11.3801 0.998047 11.3152 0.998047 11.2496C0.998047 11.184 1.01149 11.1191 1.03755 11.0589C1.06361 10.9987 1.10173 10.9445 1.14957 10.8996L7.64957 4.39957C7.69446 4.35173 7.74867 4.31361 7.80887 4.28755C7.86907 4.26149 7.93397 4.24805 7.99957 4.24805C8.06516 4.24805 8.13006 4.26149 8.19026 4.28755C8.25046 4.31361 8.30468 4.35173 8.34957 4.39957L14.8496 10.8996C14.8974 10.9445 14.9355 10.9987 14.9616 11.0589C14.9876 11.1191 15.0011 11.184 15.0011 11.2496C15.0011 11.3152 14.9876 11.3801 14.9616 11.4403C14.9355 11.5005 14.8974 11.5547 14.8496 11.5996C14.8049 11.6476 14.7507 11.6858 14.6904 11.7116C14.6302 11.7374 14.5651 11.7504 14.4996 11.7496Z\" fill=\"#6022A6\"/>\n</svg>\n",
        "accountNavigation": "/content/experience-fragments/gehealthcare/cn/zh/site/account-navigation/master",
        "popupSectionTitle": "已选定国家/地区和语言",
        "shoppingCartIcon": "/content/dam/gehc/global/icons/default-icon/ico-shoppingcart.svg",
        "noResultText": "<p>无法找到该国家/地区 — 请尝试访问全球 <a href=\"/content/gehealthcare/global/en.html\">GE HealthCare (EN)</a> 内容</p>\r\n",
        "message": "<p>您将被重定向至{}站点。不同国家/地区提供的产品和服务可能有所不同。是否要继续？</p>\r\n",
        "employeeSignoutUrl": "/api/v1/ssologout",
        "isDisplayShoppingCart": "false",
        "searchTextLabel": "搜索",
        "countrySelectorUrl": "https://qa2.gehealthcare.cn/sitemap",
        "isDisplayMyAccount": "false",
        "bodyCopy": "<p>看起来您当前在{} — 您正在浏览的是{}站点。</p>\r\n",
        "bodyText": "<p>还没有账户？</p>\r\n",
        "accountNavigationIcon": "/content/dam/gehc/global/icons/default-icon/ico-placeholderavatar-32-ic-en.svg",
        "cancelText": "取消",
        "primaryCta": {
          "url": "qa.gehealthcare.com/api/v1/login? Site=zh-cn",
          "text": "登录",
          "style": "primary-btn"
        },
        "secondaryCta": {
          "url": "/zh-cn/register",
          "text": " 立即注册",
          "style": "secondary-btn"
        },
        "navigationItems": {
          "item0": {
            "headerNavigation": "/content/experience-fragments/gehealthcare/cn/zh/site/header-navigation/products",
            "destinationLink": "https://qa2.gehealthcare.cn/products",
            "target": "_blank",
            "label": "产品",
            "headernavigation": {
              "secondaryLinks": {
                "item0": {
                  "target": "_self",
                  "linkSuffixIcon": "true",
                  "linkIcon": "<svg width=\"17\" height=\"16\" viewBox=\"0 0 17 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M5.24957 15.0005C5.18399 15.0013 5.11897 14.9884 5.05869 14.9626C4.99842 14.9367 4.94421 14.8986 4.89957 14.8505C4.85173 14.8057 4.81361 14.7514 4.78755 14.6912C4.76149 14.631 4.74805 14.5661 4.74805 14.5005C4.74805 14.4349 4.76149 14.37 4.78755 14.3098C4.81361 14.2496 4.85173 14.1954 4.89957 14.1505L11.0396 8.00054L4.89957 1.85054C4.85173 1.80565 4.81361 1.75143 4.78755 1.69124C4.76149 1.63104 4.74805 1.56614 4.74805 1.50054C4.74805 1.43495 4.76149 1.37005 4.78755 1.30985C4.81361 1.24965 4.85173 1.19543 4.89957 1.15054C4.94446 1.10271 4.99867 1.06459 5.05887 1.03853C5.11907 1.01247 5.18397 0.999023 5.24957 0.999023C5.31516 0.999023 5.38006 1.01247 5.44026 1.03853C5.50046 1.06459 5.55468 1.10271 5.59957 1.15054L12.0996 7.65054C12.1474 7.69543 12.1855 7.74965 12.2116 7.80985C12.2376 7.87005 12.2511 7.93495 12.2511 8.00054C12.2511 8.06614 12.2376 8.13104 12.2116 8.19124C12.1855 8.25143 12.1474 8.30565 12.0996 8.35054L5.59957 14.8505C5.55492 14.8986 5.50072 14.9367 5.44044 14.9626C5.38016 14.9884 5.31514 15.0013 5.24957 15.0005Z\" fill=\"#6022A6\"/>\n</svg>\n",
                  "linkText": "影像",
                  "tertiaryLinks": {
                    "target": "_self",
                    "linkSuffixIcon": "true",
                    "linkIcon": "/content/dam/gehc/global/icons/default-icon/ico-caret.svg",
                    "linkText": "影像",
                    "item0": {
                      "target": "_self",
                      "linkUrl": "https://qa2.gehealthcare.cn/products/computed-tomography",
                      "linkText": "CT"
                    },
                    "item1": {
                      "target": "_self",
                      "linkUrl": "https://qa2.gehealthcare.cn/products/magnetic-resonance-imaging",
                      "linkText": "磁共振成像"
                    },
                    "item2": {
                      "target": "_self",
                      "linkUrl": "https://qa2.gehealthcare.cn/products/molecular-imaging",
                      "linkText": "核医学"
                    },
                    "item3": {
                      "target": "_self",
                      "linkUrl": "https://qa2.gehealthcare.cn/products/interventional-image-guided-systems",
                      "linkText": "IGS"
                    },
                    "item4": {
                      "target": "_self",
                      "linkUrl": "https://qa2.gehealthcare.cn/products/radiography",
                      "linkText": "X线摄影"
                    },
                    "item5": {
                      "target": "_self",
                      "linkUrl": "https://qa2.gehealthcare.cn/products/mammography",
                      "linkText": "乳腺X线摄影"
                    },
                    "item6": {
                      "target": "_self",
                      "linkUrl": "https://qa2.gehealthcare.cn/products/bone-and-metabolic-health",
                      "linkText": "骨骼健康"
                    },
                    "item7": {
                      "target": "_self",
                      "linkUrl": "https://qa2.gehealthcare.cn/products/surgical-imaging",
                      "linkText": "外科成像"
                    }
                  }
                },
                "item1": {
                  "target": "_self",
                  "linkSuffixIcon": "true",
                  "linkIcon": "<svg width=\"17\" height=\"16\" viewBox=\"0 0 17 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M5.24957 15.0005C5.18399 15.0013 5.11897 14.9884 5.05869 14.9626C4.99842 14.9367 4.94421 14.8986 4.89957 14.8505C4.85173 14.8057 4.81361 14.7514 4.78755 14.6912C4.76149 14.631 4.74805 14.5661 4.74805 14.5005C4.74805 14.4349 4.76149 14.37 4.78755 14.3098C4.81361 14.2496 4.85173 14.1954 4.89957 14.1505L11.0396 8.00054L4.89957 1.85054C4.85173 1.80565 4.81361 1.75143 4.78755 1.69124C4.76149 1.63104 4.74805 1.56614 4.74805 1.50054C4.74805 1.43495 4.76149 1.37005 4.78755 1.30985C4.81361 1.24965 4.85173 1.19543 4.89957 1.15054C4.94446 1.10271 4.99867 1.06459 5.05887 1.03853C5.11907 1.01247 5.18397 0.999023 5.24957 0.999023C5.31516 0.999023 5.38006 1.01247 5.44026 1.03853C5.50046 1.06459 5.55468 1.10271 5.59957 1.15054L12.0996 7.65054C12.1474 7.69543 12.1855 7.74965 12.2116 7.80985C12.2376 7.87005 12.2511 7.93495 12.2511 8.00054C12.2511 8.06614 12.2376 8.13104 12.2116 8.19124C12.1855 8.25143 12.1474 8.30565 12.0996 8.35054L5.59957 14.8505C5.55492 14.8986 5.50072 14.9367 5.44044 14.9626C5.38016 14.9884 5.31514 15.0013 5.24957 15.0005Z\" fill=\"#6022A6\"/>\n</svg>\n",
                  "linkText": "超声",
                  "tertiaryLinks": {
                    "target": "_self",
                    "linkSuffixIcon": "true",
                    "linkIcon": "/content/dam/gehc/global/icons/default-icon/ico-caret.svg",
                    "linkText": "超声",
                    "item0": {
                      "target": "_self",
                      "linkUrl": "https://qa2.gehealthcare.cn/products/ultrasound/primary-care",
                      "linkText": "全身超声"
                    },
                    "item1": {
                      "target": "_self",
                      "linkUrl": "https://qa2.gehealthcare.cn/products/ultrasound/vivid",
                      "linkText": "心脏超声"
                    },
                    "item2": {
                      "target": "_self",
                      "linkUrl": "https://qa2.gehealthcare.cn/products/ultrasound/voluson",
                      "linkText": "女性健康"
                    },
                    "item3": {
                      "target": "_self",
                      "linkUrl": "https://qa2.gehealthcare.cn/products/ultrasound/point-of-care-ultrasound",
                      "linkText": "掌上超声"
                    },
                    "item4": {
                      "target": "_self",
                      "linkUrl": "https://qa2.gehealthcare.cn/products/ultrasound/high-level-disinfection-of-ultrasound-probes",
                      "linkText": "临床超声"
                    },
                    "item5": {
                      "target": "_self",
                      "linkUrl": "https://qa2.gehealthcare.cn/products/ultrasound/abus-breast-imaging",
                      "linkText": "乳腺超声"
                    }
                  }
                },
                "item2": {
                  "target": "_self",
                  "linkSuffixIcon": "true",
                  "linkIcon": "<svg width=\"17\" height=\"16\" viewBox=\"0 0 17 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M5.24957 15.0005C5.18399 15.0013 5.11897 14.9884 5.05869 14.9626C4.99842 14.9367 4.94421 14.8986 4.89957 14.8505C4.85173 14.8057 4.81361 14.7514 4.78755 14.6912C4.76149 14.631 4.74805 14.5661 4.74805 14.5005C4.74805 14.4349 4.76149 14.37 4.78755 14.3098C4.81361 14.2496 4.85173 14.1954 4.89957 14.1505L11.0396 8.00054L4.89957 1.85054C4.85173 1.80565 4.81361 1.75143 4.78755 1.69124C4.76149 1.63104 4.74805 1.56614 4.74805 1.50054C4.74805 1.43495 4.76149 1.37005 4.78755 1.30985C4.81361 1.24965 4.85173 1.19543 4.89957 1.15054C4.94446 1.10271 4.99867 1.06459 5.05887 1.03853C5.11907 1.01247 5.18397 0.999023 5.24957 0.999023C5.31516 0.999023 5.38006 1.01247 5.44026 1.03853C5.50046 1.06459 5.55468 1.10271 5.59957 1.15054L12.0996 7.65054C12.1474 7.69543 12.1855 7.74965 12.2116 7.80985C12.2376 7.87005 12.2511 7.93495 12.2511 8.00054C12.2511 8.06614 12.2376 8.13104 12.2116 8.19124C12.1855 8.25143 12.1474 8.30565 12.0996 8.35054L5.59957 14.8505C5.55492 14.8986 5.50072 14.9367 5.44044 14.9626C5.38016 14.9884 5.31514 15.0013 5.24957 15.0005Z\" fill=\"#6022A6\"/>\n</svg>\n",
                  "linkText": "生命关爱",
                  "tertiaryLinks": {
                    "target": "_self",
                    "linkSuffixIcon": "true",
                    "linkIcon": "/content/dam/gehc/global/icons/default-icon/ico-caret.svg",
                    "linkText": "生命关爱",
                    "item0": {
                      "target": "_self",
                      "linkUrl": "https://qa2.gehealthcare.cn/products/anesthesia-delivery",
                      "linkText": "麻醉机"
                    },
                    "item1": {
                      "target": "_self",
                      "linkUrl": "https://qa2.gehealthcare.cn/products/ventilators",
                      "linkText": "呼吸机"
                    },
                    "item2": {
                      "target": "_self",
                      "linkUrl": "https://qa2.gehealthcare.cn/products/maternal-infant-care",
                      "linkText": "母婴产品"
                    },
                    "item3": {
                      "target": "_self",
                      "linkUrl": "https://qa2.gehealthcare.cn/products/patient-monitoring",
                      "linkText": "患者监护"
                    },
                    "item4": {
                      "target": "_self",
                      "linkUrl": "https://qa2.gehealthcare.cn/products/diagnostic-ecg",
                      "linkText": "诊断ECG"
                    }
                  }
                },
                "item3": {
                  "target": "_self",
                  "linkSuffixIcon": "true",
                  "linkIcon": "<svg width=\"17\" height=\"16\" viewBox=\"0 0 17 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M5.24957 15.0005C5.18399 15.0013 5.11897 14.9884 5.05869 14.9626C4.99842 14.9367 4.94421 14.8986 4.89957 14.8505C4.85173 14.8057 4.81361 14.7514 4.78755 14.6912C4.76149 14.631 4.74805 14.5661 4.74805 14.5005C4.74805 14.4349 4.76149 14.37 4.78755 14.3098C4.81361 14.2496 4.85173 14.1954 4.89957 14.1505L11.0396 8.00054L4.89957 1.85054C4.85173 1.80565 4.81361 1.75143 4.78755 1.69124C4.76149 1.63104 4.74805 1.56614 4.74805 1.50054C4.74805 1.43495 4.76149 1.37005 4.78755 1.30985C4.81361 1.24965 4.85173 1.19543 4.89957 1.15054C4.94446 1.10271 4.99867 1.06459 5.05887 1.03853C5.11907 1.01247 5.18397 0.999023 5.24957 0.999023C5.31516 0.999023 5.38006 1.01247 5.44026 1.03853C5.50046 1.06459 5.55468 1.10271 5.59957 1.15054L12.0996 7.65054C12.1474 7.69543 12.1855 7.74965 12.2116 7.80985C12.2376 7.87005 12.2511 7.93495 12.2511 8.00054C12.2511 8.06614 12.2376 8.13104 12.2116 8.19124C12.1855 8.25143 12.1474 8.30565 12.0996 8.35054L5.59957 14.8505C5.55492 14.8986 5.50072 14.9367 5.44044 14.9626C5.38016 14.9884 5.31514 15.0013 5.24957 15.0005Z\" fill=\"#6022A6\"/>\n</svg>\n",
                  "linkText": "诊断药物",
                  "tertiaryLinks": {
                    "target": "_self",
                    "linkSuffixIcon": "true",
                    "linkIcon": "/content/dam/gehc/global/icons/default-icon/ico-caret.svg",
                    "linkText": "诊断药物",
                    "item0": {
                      "target": "_self",
                      "linkUrl": "https://qa2.gehealthcare.cn/products/contrast-media",
                      "linkText": "对比剂"
                    }
                  }
                }
              }
            }
          },
          "item1": {
            "headerNavigation": "/content/experience-fragments/gehealthcare/cn/zh/site/header-navigation/services",
            "destinationLink": "https://qa2.gehealthcare.cn/services",
            "target": "_blank",
            "label": "应用与服务",
            "headernavigation": {
              "secondaryLinks": {
                "item0": {
                  "target": "_self",
                  "linkSuffixIcon": "true",
                  "linkUrl": "https://qa2.gehealthcare.cn/financial-services",
                  "linkIcon": "<svg width=\"17\" height=\"16\" viewBox=\"0 0 17 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M5.24957 15.0005C5.18399 15.0013 5.11897 14.9884 5.05869 14.9626C4.99842 14.9367 4.94421 14.8986 4.89957 14.8505C4.85173 14.8057 4.81361 14.7514 4.78755 14.6912C4.76149 14.631 4.74805 14.5661 4.74805 14.5005C4.74805 14.4349 4.76149 14.37 4.78755 14.3098C4.81361 14.2496 4.85173 14.1954 4.89957 14.1505L11.0396 8.00054L4.89957 1.85054C4.85173 1.80565 4.81361 1.75143 4.78755 1.69124C4.76149 1.63104 4.74805 1.56614 4.74805 1.50054C4.74805 1.43495 4.76149 1.37005 4.78755 1.30985C4.81361 1.24965 4.85173 1.19543 4.89957 1.15054C4.94446 1.10271 4.99867 1.06459 5.05887 1.03853C5.11907 1.01247 5.18397 0.999023 5.24957 0.999023C5.31516 0.999023 5.38006 1.01247 5.44026 1.03853C5.50046 1.06459 5.55468 1.10271 5.59957 1.15054L12.0996 7.65054C12.1474 7.69543 12.1855 7.74965 12.2116 7.80985C12.2376 7.87005 12.2511 7.93495 12.2511 8.00054C12.2511 8.06614 12.2376 8.13104 12.2116 8.19124C12.1855 8.25143 12.1474 8.30565 12.0996 8.35054L5.59957 14.8505C5.55492 14.8986 5.50072 14.9367 5.44044 14.9626C5.38016 14.9884 5.31514 15.0013 5.24957 15.0005Z\" fill=\"#6022A6\"/>\n</svg>\n",
                  "linkText": "医疗金融"
                },
                "item1": {
                  "target": "_self",
                  "linkSuffixIcon": "true",
                  "linkUrl": "https://qa2.gehealthcare.cn/education",
                  "linkIcon": "<svg width=\"17\" height=\"16\" viewBox=\"0 0 17 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M5.24957 15.0005C5.18399 15.0013 5.11897 14.9884 5.05869 14.9626C4.99842 14.9367 4.94421 14.8986 4.89957 14.8505C4.85173 14.8057 4.81361 14.7514 4.78755 14.6912C4.76149 14.631 4.74805 14.5661 4.74805 14.5005C4.74805 14.4349 4.76149 14.37 4.78755 14.3098C4.81361 14.2496 4.85173 14.1954 4.89957 14.1505L11.0396 8.00054L4.89957 1.85054C4.85173 1.80565 4.81361 1.75143 4.78755 1.69124C4.76149 1.63104 4.74805 1.56614 4.74805 1.50054C4.74805 1.43495 4.76149 1.37005 4.78755 1.30985C4.81361 1.24965 4.85173 1.19543 4.89957 1.15054C4.94446 1.10271 4.99867 1.06459 5.05887 1.03853C5.11907 1.01247 5.18397 0.999023 5.24957 0.999023C5.31516 0.999023 5.38006 1.01247 5.44026 1.03853C5.50046 1.06459 5.55468 1.10271 5.59957 1.15054L12.0996 7.65054C12.1474 7.69543 12.1855 7.74965 12.2116 7.80985C12.2376 7.87005 12.2511 7.93495 12.2511 8.00054C12.2511 8.06614 12.2376 8.13104 12.2116 8.19124C12.1855 8.25143 12.1474 8.30565 12.0996 8.35054L5.59957 14.8505C5.55492 14.8986 5.50072 14.9367 5.44044 14.9626C5.38016 14.9884 5.31514 15.0013 5.24957 15.0005Z\" fill=\"#6022A6\"/>\n</svg>\n",
                  "linkText": "应用培训"
                },
                "item2": {
                  "target": "_blank",
                  "linkSuffixIcon": "true",
                  "linkUrl": "https://services.gehealthcare.cn/gehcstorefront/",
                  "linkIcon": "<svg width=\"17\" height=\"16\" viewBox=\"0 0 17 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M5.24957 15.0005C5.18399 15.0013 5.11897 14.9884 5.05869 14.9626C4.99842 14.9367 4.94421 14.8986 4.89957 14.8505C4.85173 14.8057 4.81361 14.7514 4.78755 14.6912C4.76149 14.631 4.74805 14.5661 4.74805 14.5005C4.74805 14.4349 4.76149 14.37 4.78755 14.3098C4.81361 14.2496 4.85173 14.1954 4.89957 14.1505L11.0396 8.00054L4.89957 1.85054C4.85173 1.80565 4.81361 1.75143 4.78755 1.69124C4.76149 1.63104 4.74805 1.56614 4.74805 1.50054C4.74805 1.43495 4.76149 1.37005 4.78755 1.30985C4.81361 1.24965 4.85173 1.19543 4.89957 1.15054C4.94446 1.10271 4.99867 1.06459 5.05887 1.03853C5.11907 1.01247 5.18397 0.999023 5.24957 0.999023C5.31516 0.999023 5.38006 1.01247 5.44026 1.03853C5.50046 1.06459 5.55468 1.10271 5.59957 1.15054L12.0996 7.65054C12.1474 7.69543 12.1855 7.74965 12.2116 7.80985C12.2376 7.87005 12.2511 7.93495 12.2511 8.00054C12.2511 8.06614 12.2376 8.13104 12.2116 8.19124C12.1855 8.25143 12.1474 8.30565 12.0996 8.35054L5.59957 14.8505C5.55492 14.8986 5.50072 14.9367 5.44044 14.9626C5.38016 14.9884 5.31514 15.0013 5.24957 15.0005Z\" fill=\"#6022A6\"/>\n</svg>\n",
                  "linkText": "智选商城"
                }
              }
            }
          },
          "item2": {
            "destinationLink": "https://qa2.gehealthcare.cn/about-gehc-china/company-vision",
            "target": "_self",
            "label": "中国战略"
          },
          "item3": {
            "destinationLink": "https://qa2.gehealthcare.cn/about-gehc-china/social-care",
            "target": "_self",
            "label": "可持续发展"
          },
          "item4": {
            "headerNavigation": "/content/experience-fragments/gehealthcare/cn/zh/site/header-navigation/about-us",
            "destinationLink": "https://qa2.gehealthcare.cn/about-gehc-china",
            "target": "_self",
            "label": "关于我们",
            "headernavigation": {
              "secondaryLinks": {
                "item0": {
                  "target": "_blank",
                  "linkSuffixIcon": "true",
                  "linkUrl": "https://careers.gehealthcare.com/global/en",
                  "linkIcon": "<svg width=\"17\" height=\"16\" viewBox=\"0 0 17 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M5.24957 15.0005C5.18399 15.0013 5.11897 14.9884 5.05869 14.9626C4.99842 14.9367 4.94421 14.8986 4.89957 14.8505C4.85173 14.8057 4.81361 14.7514 4.78755 14.6912C4.76149 14.631 4.74805 14.5661 4.74805 14.5005C4.74805 14.4349 4.76149 14.37 4.78755 14.3098C4.81361 14.2496 4.85173 14.1954 4.89957 14.1505L11.0396 8.00054L4.89957 1.85054C4.85173 1.80565 4.81361 1.75143 4.78755 1.69124C4.76149 1.63104 4.74805 1.56614 4.74805 1.50054C4.74805 1.43495 4.76149 1.37005 4.78755 1.30985C4.81361 1.24965 4.85173 1.19543 4.89957 1.15054C4.94446 1.10271 4.99867 1.06459 5.05887 1.03853C5.11907 1.01247 5.18397 0.999023 5.24957 0.999023C5.31516 0.999023 5.38006 1.01247 5.44026 1.03853C5.50046 1.06459 5.55468 1.10271 5.59957 1.15054L12.0996 7.65054C12.1474 7.69543 12.1855 7.74965 12.2116 7.80985C12.2376 7.87005 12.2511 7.93495 12.2511 8.00054C12.2511 8.06614 12.2376 8.13104 12.2116 8.19124C12.1855 8.25143 12.1474 8.30565 12.0996 8.35054L5.59957 14.8505C5.55492 14.8986 5.50072 14.9367 5.44044 14.9626C5.38016 14.9884 5.31514 15.0013 5.24957 15.0005Z\" fill=\"#6022A6\"/>\n</svg>\n",
                  "linkText": "招贤纳士"
                },
                "item1": {
                  "target": "_self",
                  "linkSuffixIcon": "true",
                  "linkUrl": "https://qa2.gehealthcare.cn/about-gehc-china/about-ge-healthcare-systems",
                  "linkIcon": "<svg width=\"17\" height=\"16\" viewBox=\"0 0 17 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M5.24957 15.0005C5.18399 15.0013 5.11897 14.9884 5.05869 14.9626C4.99842 14.9367 4.94421 14.8986 4.89957 14.8505C4.85173 14.8057 4.81361 14.7514 4.78755 14.6912C4.76149 14.631 4.74805 14.5661 4.74805 14.5005C4.74805 14.4349 4.76149 14.37 4.78755 14.3098C4.81361 14.2496 4.85173 14.1954 4.89957 14.1505L11.0396 8.00054L4.89957 1.85054C4.85173 1.80565 4.81361 1.75143 4.78755 1.69124C4.76149 1.63104 4.74805 1.56614 4.74805 1.50054C4.74805 1.43495 4.76149 1.37005 4.78755 1.30985C4.81361 1.24965 4.85173 1.19543 4.89957 1.15054C4.94446 1.10271 4.99867 1.06459 5.05887 1.03853C5.11907 1.01247 5.18397 0.999023 5.24957 0.999023C5.31516 0.999023 5.38006 1.01247 5.44026 1.03853C5.50046 1.06459 5.55468 1.10271 5.59957 1.15054L12.0996 7.65054C12.1474 7.69543 12.1855 7.74965 12.2116 7.80985C12.2376 7.87005 12.2511 7.93495 12.2511 8.00054C12.2511 8.06614 12.2376 8.13104 12.2116 8.19124C12.1855 8.25143 12.1474 8.30565 12.0996 8.35054L5.59957 14.8505C5.55492 14.8986 5.50072 14.9367 5.44044 14.9626C5.38016 14.9884 5.31514 15.0013 5.24957 15.0005Z\" fill=\"#6022A6\"/>\n</svg>\n",
                  "linkText": "简介"
                },
                "item2": {
                  "target": "_self",
                  "linkSuffixIcon": "true",
                  "linkUrl": "https://qa2.gehealthcare.cn/china-news",
                  "linkIcon": "<svg width=\"17\" height=\"16\" viewBox=\"0 0 17 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M5.24957 15.0005C5.18399 15.0013 5.11897 14.9884 5.05869 14.9626C4.99842 14.9367 4.94421 14.8986 4.89957 14.8505C4.85173 14.8057 4.81361 14.7514 4.78755 14.6912C4.76149 14.631 4.74805 14.5661 4.74805 14.5005C4.74805 14.4349 4.76149 14.37 4.78755 14.3098C4.81361 14.2496 4.85173 14.1954 4.89957 14.1505L11.0396 8.00054L4.89957 1.85054C4.85173 1.80565 4.81361 1.75143 4.78755 1.69124C4.76149 1.63104 4.74805 1.56614 4.74805 1.50054C4.74805 1.43495 4.76149 1.37005 4.78755 1.30985C4.81361 1.24965 4.85173 1.19543 4.89957 1.15054C4.94446 1.10271 4.99867 1.06459 5.05887 1.03853C5.11907 1.01247 5.18397 0.999023 5.24957 0.999023C5.31516 0.999023 5.38006 1.01247 5.44026 1.03853C5.50046 1.06459 5.55468 1.10271 5.59957 1.15054L12.0996 7.65054C12.1474 7.69543 12.1855 7.74965 12.2116 7.80985C12.2376 7.87005 12.2511 7.93495 12.2511 8.00054C12.2511 8.06614 12.2376 8.13104 12.2116 8.19124C12.1855 8.25143 12.1474 8.30565 12.0996 8.35054L5.59957 14.8505C5.55492 14.8986 5.50072 14.9367 5.44044 14.9626C5.38016 14.9884 5.31514 15.0013 5.24957 15.0005Z\" fill=\"#6022A6\"/>\n</svg>\n",
                  "linkText": "新闻中心"
                }
              }
            }
          },
          "item5": {
            "destinationLink": "https://qa2.gehealthcare.cn/about-gehc-china/contact-us",
            "target": "_self",
            "label": "联系我们"
          }
        },
        "countryGroups": {
          "item0": {
            "countryList": "/etc/acs-commons/lists/gehealthcare/pn-country-selector-groups/africa",
            "groupHeader": "Africa"
          },
          "item1": {
            "countryList": "/etc/acs-commons/lists/gehealthcare/pn-country-selector-groups/americas",
            "groupHeader": "Americas"
          },
          "item2": {
            "countryList": "/etc/acs-commons/lists/gehealthcare/pn-country-selector-groups/asia",
            "groupHeader": " Asia"
          },
          "item3": {
            "countryList": "/etc/acs-commons/lists/gehealthcare/pn-country-selector-groups/europe",
            "groupHeader": "Europe"
          },
          "item4": {
            "countryList": "/etc/acs-commons/lists/gehealthcare/pn-country-selector-groups/oceania",
            "groupHeader": "Oceania"
          }
        }
      }
    },
    {
      "carousel-container": {
        "testimonialBackgroundColor": "white",
        "enableSlideNavTitleList": "true",
        "suffixIcon": "true",
        "eyebrow": "<p>Clinical Images</p>\r\n",
        "isCarouselCountDisabled": "false",
        "displayInStickyNav": "false",
        "productMediaCarouselBackgroundColor": "white",
        "target": "_self",
        "carouselVariationClass": "ge-homepage-hero-carousel",
        "autopauseDisabled": "true",
        "text": "See all clinical imaging",
        "delay": "8",
        "style": "primary-btn",
        "storyBackgroundColor": "white",
        "storyGalleryCarouselBackgroundColor": "white",
        "isHideKeylinePaginationIndicator": "false",
        "autoplay": "false",
        "homepageherocarousel-1": {
          "isLoopVideo": "true",
          "fileReference": {
            "dmId": "DynamicMedia-1398730865-371e87e4-f17c-4ec6-bdbd-0dd569397176-f56467d7c2744b53a64eb1c4570d0e2b",
            "assetPath": "gehealthcarestage/story%20carosuel%20%203",
            "assetName": "/images/gehealthcarestage/story_carosuel__3.jpg",
            "viewerPath": "https://s7d9.scene7.com/s7viewers/",
            "serverPath": "https://s7d9.scene7.com/is/image/"
          },
          "cq:panelTitle": "01",
          "suffixIcon": "true",
          "target": "_self",
          "bodyCopyText": "<p>首页轮播图测试</p>\r\n",
          "showIcon": "false",
          "isSinglePlayVideo": "true",
          "url": "https://qa2.gehealthcare.cn/about/contact-us-clariscan",
          "icon": "<svg width=\"17\" height=\"16\" viewBox=\"0 0 17 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M5.24957 15.0005C5.18399 15.0013 5.11897 14.9884 5.05869 14.9626C4.99842 14.9367 4.94421 14.8986 4.89957 14.8505C4.85173 14.8057 4.81361 14.7514 4.78755 14.6912C4.76149 14.631 4.74805 14.5661 4.74805 14.5005C4.74805 14.4349 4.76149 14.37 4.78755 14.3098C4.81361 14.2496 4.85173 14.1954 4.89957 14.1505L11.0396 8.00054L4.89957 1.85054C4.85173 1.80565 4.81361 1.75143 4.78755 1.69124C4.76149 1.63104 4.74805 1.56614 4.74805 1.50054C4.74805 1.43495 4.76149 1.37005 4.78755 1.30985C4.81361 1.24965 4.85173 1.19543 4.89957 1.15054C4.94446 1.10271 4.99867 1.06459 5.05887 1.03853C5.11907 1.01247 5.18397 0.999023 5.24957 0.999023C5.31516 0.999023 5.38006 1.01247 5.44026 1.03853C5.50046 1.06459 5.55468 1.10271 5.59957 1.15054L12.0996 7.65054C12.1474 7.69543 12.1855 7.74965 12.2116 7.80985C12.2376 7.87005 12.2511 7.93495 12.2511 8.00054C12.2511 8.06614 12.2376 8.13104 12.2116 8.19124C12.1855 8.25143 12.1474 8.30565 12.0996 8.35054L5.59957 14.8505C5.55492 14.8986 5.50072 14.9367 5.44044 14.9626C5.38016 14.9884 5.31514 15.0013 5.24957 15.0005Z\" fill=\"#6022A6\"/>\n</svg>\n",
          "text": "报名",
          "style": "link-cta",
          "title": "<p>首页轮播图测试一<br>\r\n<br>\r\n</p>\r\n",
          "videoType": "aemDAMVideo",
          "mediaType": "image"
        },
        "homepageherocarousel-2": {
          "isLoopVideo": "true",
          "fileReference": {
            "dmId": "DynamicMedia-1398730865-183ec0e2-b136-4e17-a0b4-2c82ae021c14-08a4d04f7ef7453da7c85fcd05746004",
            "assetPath": "gehealthcarestage/Rectangle%20367.jpg-1",
            "assetName": "/images/gehealthcarestage/Rectangle_367.jpg-1",
            "viewerPath": "https://s7d9.scene7.com/s7viewers/",
            "serverPath": "https://s7d9.scene7.com/is/image/"
          },
          "cq:panelTitle": "02",
          "suffixIcon": "true",
          "target": "_self",
          "bodyCopyText": "<p>样本</p>\r\n",
          "showIcon": "false",
          "isSinglePlayVideo": "true",
          "url": "https://qa2.gehealthcare.cn/education",
          "icon": "<svg width=\"17\" height=\"16\" viewBox=\"0 0 17 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M5.24957 15.0005C5.18399 15.0013 5.11897 14.9884 5.05869 14.9626C4.99842 14.9367 4.94421 14.8986 4.89957 14.8505C4.85173 14.8057 4.81361 14.7514 4.78755 14.6912C4.76149 14.631 4.74805 14.5661 4.74805 14.5005C4.74805 14.4349 4.76149 14.37 4.78755 14.3098C4.81361 14.2496 4.85173 14.1954 4.89957 14.1505L11.0396 8.00054L4.89957 1.85054C4.85173 1.80565 4.81361 1.75143 4.78755 1.69124C4.76149 1.63104 4.74805 1.56614 4.74805 1.50054C4.74805 1.43495 4.76149 1.37005 4.78755 1.30985C4.81361 1.24965 4.85173 1.19543 4.89957 1.15054C4.94446 1.10271 4.99867 1.06459 5.05887 1.03853C5.11907 1.01247 5.18397 0.999023 5.24957 0.999023C5.31516 0.999023 5.38006 1.01247 5.44026 1.03853C5.50046 1.06459 5.55468 1.10271 5.59957 1.15054L12.0996 7.65054C12.1474 7.69543 12.1855 7.74965 12.2116 7.80985C12.2376 7.87005 12.2511 7.93495 12.2511 8.00054C12.2511 8.06614 12.2376 8.13104 12.2116 8.19124C12.1855 8.25143 12.1474 8.30565 12.0996 8.35054L5.59957 14.8505C5.55492 14.8986 5.50072 14.9367 5.44044 14.9626C5.38016 14.9884 5.31514 15.0013 5.24957 15.0005Z\" fill=\"#6022A6\"/>\n</svg>\n",
          "text": "Learn more",
          "style": "link-cta",
          "title": "<p>首页轮播图测试样本</p>\r\n",
          "videoType": "aemDAMVideo",
          "mediaType": "image"
        },
        "homepageherocarousel-3": {
          "isLoopVideo": "true",
          "fileReference": {
            "dmId": "DynamicMedia-1398730865-281b90eb-7a27-48be-a548-1b7009b18a50-2f1487ff4d1b4b00b23fbda75e2f6479",
            "assetPath": "gehealthcarestage/story%20carosuel",
            "assetName": "/images/gehealthcarestage/story_carosuel.jpg",
            "viewerPath": "https://s7d9.scene7.com/s7viewers/",
            "serverPath": "https://s7d9.scene7.com/is/image/"
          },
          "cq:panelTitle": "03",
          "suffixIcon": "true",
          "target": "_self",
          "bodyCopyText": "<p>中国某测试网站首页轮播图示例</p>\r\n",
          "showIcon": "false",
          "isSinglePlayVideo": "true",
          "url": "https://qa2.gehealthcare.cn/china-news/announcement-0227",
          "icon": "<svg width=\"17\" height=\"16\" viewBox=\"0 0 17 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M5.24957 15.0005C5.18399 15.0013 5.11897 14.9884 5.05869 14.9626C4.99842 14.9367 4.94421 14.8986 4.89957 14.8505C4.85173 14.8057 4.81361 14.7514 4.78755 14.6912C4.76149 14.631 4.74805 14.5661 4.74805 14.5005C4.74805 14.4349 4.76149 14.37 4.78755 14.3098C4.81361 14.2496 4.85173 14.1954 4.89957 14.1505L11.0396 8.00054L4.89957 1.85054C4.85173 1.80565 4.81361 1.75143 4.78755 1.69124C4.76149 1.63104 4.74805 1.56614 4.74805 1.50054C4.74805 1.43495 4.76149 1.37005 4.78755 1.30985C4.81361 1.24965 4.85173 1.19543 4.89957 1.15054C4.94446 1.10271 4.99867 1.06459 5.05887 1.03853C5.11907 1.01247 5.18397 0.999023 5.24957 0.999023C5.31516 0.999023 5.38006 1.01247 5.44026 1.03853C5.50046 1.06459 5.55468 1.10271 5.59957 1.15054L12.0996 7.65054C12.1474 7.69543 12.1855 7.74965 12.2116 7.80985C12.2376 7.87005 12.2511 7.93495 12.2511 8.00054C12.2511 8.06614 12.2376 8.13104 12.2116 8.19124C12.1855 8.25143 12.1474 8.30565 12.0996 8.35054L5.59957 14.8505C5.55492 14.8986 5.50072 14.9367 5.44044 14.9626C5.38016 14.9884 5.31514 15.0013 5.24957 15.0005Z\" fill=\"#6022A6\"/>\n</svg>\n",
          "text": "中国某测试网站",
          "style": "link-cta",
          "title": "<p>样本</p>\r\n",
          "videoType": "aemDAMVideo",
          "mediaType": "image"
        }
      }
    },
    {
      "highlightkeystats": {
        "stickyNavLinkText": "HighlightsV2",
        "displayInStickyNav": "true",
        "variation": "Key Stats",
        "backgroundColor": "gray-100",
        "statsItems": {
          "item0": {
            "bodyCopyText": "<p>每年服务患者数量&nbsp;每年服务患者数量&nbsp;患者数量患者数量患者数量患者数量患者数量</p>\r\n",
            "stats": "<p>10亿+</p>\r\n"
          },
          "item1": {
            "bodyCopyText": "<p>面向客户的员工数量</p>\r\n",
            "stats": "<p>1.43万</p>\r\n"
          },
          "item2": {
            "bodyCopyText": "<p>全球装机量</p>\r\n",
            "stats": "<p>500.76万+</p>\r\n"
          },
          "item3": {
            "bodyCopyText": "<p>研发与产品服务的年均投资额患者数量</p>\r\n",
            "stats": "<p>10亿美元TESTStats</p>\r\n"
          }
        }
      }
    },
    {
      "carousel-container-2": {
        "stickyNavLinkText": "产品系列",
        "testimonialBackgroundColor": "white",
        "enableSlideNavTitleList": "true",
        "suffixIcon": "true",
        "eyebrow": "<p>Clinical Images</p>\r\n",
        "isCarouselCountDisabled": "false",
        "displayInStickyNav": "true",
        "productMediaCarouselBackgroundColor": "white",
        "target": "_self",
        "carouselVariationClass": "ge-product-card-carousel",
        "autopauseDisabled": "true",
        "productCardTitle": "<p>磁共振成像</p>\r\n",
        "text": "See all clinical imaging",
        "style": "primary-btn",
        "storyBackgroundColor": "white",
        "storyGalleryCarouselBackgroundColor": "white",
        "isHideKeylinePaginationIndicator": "false",
        "autoplay": "false",
        "productcardcarousel-1": {
          "fileReference": {
            "dmId": "DynamicMedia-1398730865-8aba5806-c946-46bc-971b-93c10473227c-6c37a7771b294918b1073f94c685016c",
            "assetPath": "gehealthcarestage/1781346034335-1738664945378-Vscan-Air-SL---Image-1",
            "assetName": "/images/gehealthcarestage/1781346034335-1738664945378-Vscan-Air-SL---Image-1.png",
            "viewerPath": "https://s7d9.scene7.com/s7viewers/",
            "serverPath": "https://s7d9.scene7.com/is/image/"
          },
          "cq:panelTitle": "01",
          "cardLinkTarget": "_self",
          "cardName": "<p>CT</p>\r\n",
          "cardImageLink": "https://qa2.gehealthcare.cn/products/magnetic-resonance-imaging"
        },
        "productcardcarousel-2": {
          "fileReference": {
            "dmId": "DynamicMedia-1398730865-04946a47-e457-44ac-b13a-e745d1060fb5-e49c30aadcba493cbec3ac03ff47560a",
            "assetPath": "gehealthcarestage/1781243178472-istockphoto",
            "assetName": "/images/gehealthcarestage/1781243178472-istockphoto.jpg",
            "viewerPath": "https://s7d9.scene7.com/s7viewers/",
            "serverPath": "https://s7d9.scene7.com/is/image/"
          },
          "cq:panelTitle": "02",
          "cardLinkTarget": "_self",
          "cardName": "<p>产品4</p>\r\n",
          "cardImageLink": "https://qa2.gehealthcare.cn/products/molecular-imaging"
        },
        "productcardcarousel-3": {
          "fileReference": {
            "dmId": "DynamicMedia-1398730865-4d06712a-3122-4773-8d77-00f618273598-1f111bb12d4949ab8c3722449de4b84b",
            "assetPath": "gehealthcarestage/1781242835339-test---3",
            "assetName": "/images/gehealthcarestage/1781242835339-test---3.jpg",
            "viewerPath": "https://s7d9.scene7.com/s7viewers/",
            "serverPath": "https://s7d9.scene7.com/is/image/"
          },
          "cq:panelTitle": "03",
          "cardLinkTarget": "_self",
          "cardName": "<p>产品5</p>\r\n",
          "cardImageLink": "https://qa2.gehealthcare.cn/products/patient-monitoring"
        },
        "productcardcarousel-4": {
          "fileReference": {
            "dmId": "DynamicMedia-1398730865-9cd233bf-1313-402e-a188-06ec4133b1b1-466380d17a0f4f74a8b732f87768e0cb",
            "assetPath": "gehealthcarestage/1781085321504-test-1",
            "assetName": "/images/gehealthcarestage/1781085321504-test-1.jpg",
            "viewerPath": "https://s7d9.scene7.com/s7viewers/",
            "serverPath": "https://s7d9.scene7.com/is/image/"
          },
          "cq:panelTitle": "04",
          "cardLinkTarget": "_self",
          "cardName": "<p>产品7</p>\r\n",
          "cardImageLink": "https://qa2.gehealthcare.cn/products/patient-monitoring"
        },
        "productcardcarousel-5": {
          "fileReference": {
            "dmId": "DynamicMedia-1398730865-80f9f9c6-267b-48f7-bc75-d4db6f891da5-677f4252c7e44cb8a65d9386e887a0df",
            "assetPath": "gehealthcarestage/Picture1",
            "assetName": "/images/gehealthcarestage/Picture1.png",
            "viewerPath": "https://s7d9.scene7.com/s7viewers/",
            "serverPath": "https://s7d9.scene7.com/is/image/"
          },
          "cq:panelTitle": "05",
          "cardAltText": "Product Card Carousel 5",
          "cardLinkTarget": "_self",
          "cardName": "<p>产品Product Card5</p>\r\n",
          "cardImageLink": "https://qa.gehealthcare.com/en-us/campaigns"
        },
        "productcardcarousel-6": {
          "fileReference": {
            "dmId": "DynamicMedia-1398730865-797ba5be-44d9-4f97-8998-ea8e67e6bbff-434d63ba4e0d4ef288ad489d85d39ba0",
            "assetPath": "gehealthcarestage/story%20carosuel%20%202",
            "assetName": "/images/gehealthcarestage/story_carosuel__2.png",
            "viewerPath": "https://s7d9.scene7.com/s7viewers/",
            "serverPath": "https://s7d9.scene7.com/is/image/"
          },
          "cq:panelTitle": "06",
          "cardAltText": "Product Card Carousel 6产品",
          "cardLinkTarget": "_blank",
          "cardName": "<p>Card 6</p>\r\n",
          "cardImageLink": "https://qa2.gehealthcare.cn/products/anesthesia-delivery"
        },
        "productcardcarousel-7": {
          "fileReference": {
            "dmId": "DynamicMedia-1398730865-9eab395e-bbb4-4654-990a-09e07cc664e5-7be020b1fe8d4b36b049fe1e13fdd294",
            "assetPath": "gehealthcarestage/product%20media%203",
            "assetName": "/images/gehealthcarestage/product_media_3.png",
            "viewerPath": "https://s7d9.scene7.com/s7viewers/",
            "serverPath": "https://s7d9.scene7.com/is/image/"
          },
          "cq:panelTitle": "07",
          "cardAltText": "Product Card Carousel 7",
          "cardLinkTarget": "_self",
          "cardName": "<p>Card 7 test test test7</p>\r\n",
          "cardImageLink": "https://qa2.gehealthcare.cn/products/computed-tomography"
        },
        "productcardcarousel-8": {
          "fileReference": {
            "dmId": "DynamicMedia-1398730865-183ec0e2-b136-4e17-a0b4-2c82ae021c14-cf4f66d18f1047a8aa593f207c12c6ab",
            "assetPath": "gehealthcarestage/Rectangle%20367.jpg-1",
            "assetName": "/images/gehealthcarestage/Rectangle_367.jpg-1",
            "viewerPath": "https://s7d9.scene7.com/s7viewers/",
            "serverPath": "https://s7d9.scene7.com/is/image/"
          },
          "cq:panelTitle": "08",
          "cardAltText": "Product Card Carousel 8",
          "cardLinkTarget": "_newWindow",
          "cardName": "<p>Card 8</p>\r\n",
          "cardImageLink": "https://qa2.gehealthcare.cn/about"
        },
        "productcardcarousel-9": {
          "fileReference": {
            "dmId": "DynamicMedia-1398730865-80f9f9c6-267b-48f7-bc75-d4db6f891da5-19c98f572e06409486b6c9a6d8776a77",
            "assetPath": "gehealthcarestage/Picture1",
            "assetName": "/images/gehealthcarestage/Picture1.png",
            "viewerPath": "https://s7d9.scene7.com/s7viewers/",
            "serverPath": "https://s7d9.scene7.com/is/image/"
          },
          "cq:panelTitle": "09",
          "cardAltText": "Product Card Carousel 9",
          "cardLinkTarget": "_self",
          "cardName": "<p>Card 9</p>\r\n",
          "cardImageLink": "https://qa2.gehealthcare.cn/products/computed-tomography/apex-expert"
        },
        "productcardcarousel-10": {
          "fileReference": {
            "dmId": "DynamicMedia-1398730865-281b90eb-7a27-48be-a548-1b7009b18a50-c7da16d4aa984b6c869c1772f151509c",
            "assetPath": "gehealthcarestage/story%20carosuel",
            "assetName": "/images/gehealthcarestage/story_carosuel.jpg",
            "viewerPath": "https://s7d9.scene7.com/s7viewers/",
            "serverPath": "https://s7d9.scene7.com/is/image/"
          },
          "cq:panelTitle": "10",
          "cardAltText": "Product Card Carousel 10",
          "cardLinkTarget": "_self",
          "cardName": "<p>Card 10产品</p>\r\n",
          "cardImageLink": "https://qa2.gehealthcare.cn/products/computed-tomography"
        }
      }
    },
    {
      "relatedcontent": {
        "stickyNavLinkText": "相关内容",
        "suffixIcon": "true",
        "eyebrow": "<p>Related Content Eyebrow</p>\r\n",
        "displayInStickyNav": "true",
        "relatedCategoryTags": "[Ljava.lang.String;@7d6fd3e0",
        "target": "_self",
        "bgColor": "bg-white",
        "variation": "manual-variation",
        "url": "https://qa2.gehealthcare.cn/china-news",
        "icon": "<svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M4.74957 15.0005C4.68399 15.0013 4.61897 14.9884 4.55869 14.9626C4.49842 14.9367 4.44421 14.8986 4.39957 14.8505C4.35173 14.8057 4.31361 14.7514 4.28755 14.6912C4.26149 14.631 4.24805 14.5661 4.24805 14.5005C4.24805 14.4349 4.26149 14.37 4.28755 14.3098C4.31361 14.2496 4.35173 14.1954 4.39957 14.1505L10.5396 8.00054L4.39957 1.85054C4.35173 1.80565 4.31361 1.75143 4.28755 1.69124C4.26149 1.63104 4.24805 1.56614 4.24805 1.50054C4.24805 1.43495 4.26149 1.37005 4.28755 1.30985C4.31361 1.24965 4.35173 1.19543 4.39957 1.15054C4.44446 1.10271 4.49867 1.06459 4.55887 1.03853C4.61907 1.01247 4.68397 0.999023 4.74957 0.999023C4.81516 0.999023 4.88006 1.01247 4.94026 1.03853C5.00046 1.06459 5.05468 1.10271 5.09957 1.15054L11.5996 7.65054C11.6474 7.69543 11.6855 7.74965 11.7116 7.80985C11.7376 7.87005 11.7511 7.93495 11.7511 8.00054C11.7511 8.06614 11.7376 8.13104 11.7116 8.19124C11.6855 8.25143 11.6474 8.30565 11.5996 8.35054L5.09957 14.8505C5.05492 14.8986 5.00072 14.9367 4.94044 14.9626C4.88016 14.9884 4.81514 15.0013 4.74957 15.0005Z\" fill=\"#222222\"/>\n</svg>\n",
        "text": "所有新闻",
        "style": "link-cta",
        "title": "<p>新闻中心</p>\r\n",
        "readTimeText": "min read",
        "targetAutomaticCardItem": "_self",
        "relatedContentTags": "[Ljava.lang.String;@359c6558",
        "minuteText": "min",
        "minutesText": "mins",
        "cardLayoutOption": "4",
        "manualContentItems": {
          "item0": {
            "fileReference": {
              "dmId": "DynamicMedia-1398730865-183ec0e2-b136-4e17-a0b4-2c82ae021c14-a80bd741b99841658747716cbb74415f",
              "assetPath": "gehealthcarestage/Rectangle%20367.jpg-1",
              "assetName": "/images/gehealthcarestage/Rectangle_367.jpg-1",
              "viewerPath": "https://s7d9.scene7.com/s7viewers/",
              "serverPath": "https://s7d9.scene7.com/is/image/"
            },
            "headline": "<p>GE医疗携50余款创新成果参展CMEF，首推临床疾病解决方案</p>\r\n",
            "altText": "picture02",
            "imageLink": "https://qa2.gehealthcare.cn/china-news",
            "linkTarget": "_self",
            "videoType": "aemDAMVideo",
            "mediaType": "image"
          },
          "item1": {
            "fileReference": {
              "dmId": "DynamicMedia-1398730865-d8e959c5-6d0e-4737-ae56-58fd7416995d-01c04c6ed111418689d1c02945ba7eb0",
              "assetPath": "gehealthcarestage/Rectangle%201372%20(1)%20(1)-4",
              "assetName": "/images/gehealthcarestage/Rectangle_1372_(1)_(1)-4.png",
              "viewerPath": "https://s7d9.scene7.com/s7viewers/",
              "serverPath": "https://s7d9.scene7.com/is/image/"
            },
            "headline": "<p>GE医疗携手中国人口福利基金会向云南威信县捐赠X光机</p>\r\n",
            "altText": "picture02",
            "imageLink": "https://qa2.gehealthcare.cn/china-news/ge-news-2025-03",
            "linkTarget": "_self",
            "videoType": "aemDAMVideo",
            "mediaType": "image"
          },
          "item2": {
            "fileReference": {
              "dmId": "DynamicMedia-1398730865-b846ffe6-dd05-4fe0-a30d-053e5a5796ad-ac55249bb71b496696104d28fea90219",
              "assetPath": "gehealthcarestage/Biomed%20looking%20at%20IT%20system-1",
              "assetName": "/images/gehealthcarestage/Biomed_looking_at_IT_system-1.png",
              "viewerPath": "https://s7d9.scene7.com/s7viewers/",
              "serverPath": "https://s7d9.scene7.com/is/image/"
            },
            "headline": "<p>GE医疗上海创中心发布三大数字化生态平台</p>\r\n",
            "altText": "picture02",
            "imageLink": "https://qa2.gehealthcare.cn/china-news/ge-news-2025-04",
            "linkTarget": "_self",
            "videoType": "aemDAMVideo",
            "mediaType": "image"
          },
          "item3": {
            "fileReference": {
              "dmId": "DynamicMedia-1398730865-4c46df68-c7a6-4c39-9979-2657356c962f-a48269c9b0ea412db7c90c02f8c70510",
              "assetPath": "gehealthcarestage/cq5dam.web.1280.1280-2",
              "assetName": "/images/gehealthcarestage/cq5dam.web.1280.1280-2",
              "viewerPath": "https://s7d9.scene7.com/s7viewers/",
              "serverPath": "https://s7d9.scene7.com/is/image/"
            },
            "headline": "<p>GE医疗中国携80款创新成果参展CMEF 2025，国产创新达历史新高</p>\r\n",
            "altText": "picture02",
            "imageLink": "https://qa2.gehealthcare.cn/china-news",
            "linkTarget": "_self",
            "videoType": "aemDAMVideo",
            "mediaType": "image"
          }
        }
      }
    },
    {
      "contactus": {
        "stickyNavLinkText": "Contact",
        "captionText": "Enter your email address",
        "contactUsVariation": "form",
        "suffixIcon": "true",
        "formId": "",
        "displayInStickyNav": "true",
        "target": "_popupForm",
        "marketoFormTabIndex": "1",
        "placeHolderText": "name@domain.com",
        "bgColor": "bg-grey-100",
        "url": "/#",
        "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><g id=\"ico-3d-rotate-32-2\" data-name=\"ico-3d-rotate-32\"><path d=\"M6.92,19.59a1,1,0,0,1-.92.62,1.09,1.09,0,0,1-.39-.08C2,18.61,0,16.44,0,14c0-2.17,1.61-4.19,4.55-5.68a1,1,0,0,1,1.34.43,1,1,0,0,1-.44,1.35C3.26,11.22,2,12.64,2,14c0,1.56,1.6,3.12,4.39,4.28A1,1,0,0,1,6.92,19.59ZM31.8,12.7a1,1,0,0,0-1.91.59A2.5,2.5,0,0,1,30,14c0,2.84-5.75,6-14,6-.83,0-1.66-.05-2.47-.11l2.18-2.18a1,1,0,0,0-1.42-1.42l-4,4a1,1,0,0,0,0,1.42l4,4a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42l-2.42-2.42c.89.08,1.8.13,2.71.13,9,0,16-3.51,16-8A4.46,4.46,0,0,0,31.8,12.7ZM21.93,24.06a1,1,0,0,0-1.27.61C19.49,28,17.75,30,16,30c-1.35,0-2.76-1.26-3.87-3.45a1,1,0,1,0-1.78.9C11.82,30.38,13.83,32,16,32c2.67,0,5.06-2.43,6.54-6.67A1,1,0,0,0,21.93,24.06ZM16,2c2.45,0,4.33,4.13,4.85,10.44l-2.14-2.15a1,1,0,0,0-1.42,1.42l4,4a1,1,0,0,0,1.42,0l4-4a1,1,0,0,0-1.42-1.42L22.88,12.7C22.31,4.73,19.78,0,16,0,11.51,0,8,7,8,16a1,1,0,0,0,2,0C10,7.75,13.16,2,16,2Z\"/></g></svg>",
        "text": "联系我们 Test contact",
        "whereToUse": "ge",
        "style": "primary-btn",
        "sectionTitle": "<p>有问题吗？我们希望收到您的来信。</p>\r\n",
        "secondaryCta": {
          "suffixIcon": "true",
          "formId": "",
          "target": "_newWindow",
          "marketoFormTabIndex": "1",
          "url": "https://qa2.gehealthcare.cn/products/anesthesia-delivery",
          "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" enable-background=\"new 0 0 16 16\"><title>ico-mpr3d</title><path d=\"M14.7 3.5L7.7 0c-.1 0-.3 0-.4 0l-7 3.5c-.2.1-.3.3-.3.5v8c0 .2.1.4.3.4l7 3.5c.1.1.3.1.4 0l7-3.5c.2-.1.3-.3.3-.4V4c0-.2-.1-.4-.3-.5zM7.5 1.1L13.4 4 7.5 6.9 1.6 4l5.9-2.9zM1 4.8l6 3v6.9l-6-3V4.8z\"/></svg>",
          "text": "Secondary",
          "style": "secondary-btn"
        }
      }
    },
    {
      "footernavigation": {
        "isLinkLogoImageToHomepage": "true",
        "logoReference": {
          "dmId": "DynamicMedia-1398730865-549b6848-0a15-4761-a32c-900e7a79a219-30590f6d4402446eb565d6486ceb4134",
          "assetPath": "gehealthcarestage/logo-Light-GEHC-8",
          "assetName": "/images/gehealthcarestage/logo-Light-GEHC-8.png",
          "viewerPath": "https://s7d9.scene7.com/s7viewers/",
          "serverPath": "https://s7d9.scene7.com/is/image/"
        },
        "bottomLeftColumnText": "<p>© 2026 GE HealthCare. GE 是 General Electric Company 在商标许可下使用的商标。</p>\r\n<p>通用电气医疗系统贸易发展(上海)有限公司</p>\r\n",
        "topLeftColumnText": "<p>如需报告药品不良事件,请联系GE医疗中国药物安全部</p>\r\n<p><a href=\"mailto:ADR.China@gehealthcare.com\">ADR.China@gehealthcare.com</a></p>\r\n",
        "cookiePreferencesText": "cookie 偏好",
        "bottomRightColumnText": "<p><a rel=\"noopener noreferrer\" target=\"_self\" href=\"/content/gehealthcare/cn/zh/about-gehc-china/privacy/privacy-policy.html\">隐私政策</a>&nbsp;&nbsp;<a rel=\"noopener noreferrer\" href=\"https://www.gehealthcare.com/en/about/terms-and-conditions\" target=\"_blank\">条款和条件</a>&nbsp;&nbsp;<a rel=\"noopener noreferrer\" target=\"_blank\" href=\"https://www.gehealthcare.com/content/dam/gehc/sitecore-migrated-assets/gehc/cn/files/others/home-page/2025_0018_20250311.pdf\">沪网药信备字〔2025〕00018号</a>&nbsp;&nbsp;<a rel=\"noopener noreferrer\" target=\"_blank\" href=\"https://beian.miit.gov.cn/\">沪ICP备11019805号-10</a>&nbsp;&nbsp;<a rel=\"noopener noreferrer\" href=\"http://www.beian.gov.cn/\" target=\"_blank\">沪公网安备31011502016102号</a>&nbsp;&nbsp;<a rel=\"noopener noreferrer\" href=\"https://www.gehealthcare.com/productsecurity/home\" target=\"_blank\">安全性</a></p>\r\n",
        "sociallinks": {},
        "countryselector": {
          "modalBodyCopy": "<p>您似乎位于&nbsp;{userLocation}.</p>\r\n<p>您正在浏览 {siteLocation}&nbsp;网站。要查看您所在特定位置的内容，请选择下方相关的 <i>国家/地区</i> <u>或</u> <sub>地区</sub> <sup>。</sup></p>\r\n",
          "countryIcon": "<svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C15.9941 3.58418 12.4158 0.00592331 8 0ZM8 15.0538C7 15.0538 5.91935 13.3548 5.46774 10.6882H10.5323C10.0806 13.3763 9 15.0538 8 15.0538ZM5.31183 9.6129C5.26344 9.10215 5.23656 8.56452 5.23656 8C5.23656 7.43548 5.23656 6.89785 5.31183 6.3871H10.6882C10.7366 6.89785 10.7634 7.43548 10.7634 8C10.7634 8.56452 10.7366 9.10215 10.6882 9.6129H5.31183ZM0.946237 8C0.948567 7.45703 1.01168 6.91602 1.13441 6.3871H4.36022C4.31183 6.92473 4.28495 7.46237 4.28495 8C4.28495 8.53763 4.31183 9.07527 4.36022 9.6129H1.13441C1.01168 9.08398 0.948567 8.54297 0.946237 8ZM8 0.946237C9 0.946237 10.0806 2.64516 10.5323 5.31183H5.46774C5.91935 2.62366 7 0.946237 8 0.946237ZM11.6237 6.3871H14.8495C15.101 7.44766 15.101 8.55234 14.8495 9.6129H11.6237C11.672 9.07527 11.6989 8.53763 11.6989 8C11.6989 7.46237 11.672 6.92473 11.6237 6.3871ZM14.5215 5.31183H11.4839C11.3044 3.85686 10.793 2.46257 9.98925 1.23656C12.0373 1.84197 13.7026 3.33942 14.5215 5.31183ZM6.01075 1.23656C5.20698 2.46257 4.69562 3.85686 4.51613 5.31183H1.47849C2.29736 3.33942 3.96273 1.84197 6.01075 1.23656ZM1.47849 10.6882H4.51613C4.69562 12.1431 5.20698 13.5374 6.01075 14.7634C3.96273 14.158 2.29736 12.6606 1.47849 10.6882ZM9.98925 14.7634C10.793 13.5374 11.3044 12.1431 11.4839 10.6882H14.5215C13.7026 12.6606 12.0373 14.158 9.98925 14.7634Z\" fill=\"#222222\"/>\n</svg>\n",
          "modalTitle": "选择您的位置",
          "modalCaption": "*您所在的国家或地区可能并不提供所有产品和服务。",
          "modalCountryLabel": "国家",
          "searchText": "搜索",
          "modalCountry": "/etc/acs-commons/lists/gehealthcare/country-selector-list",
          "countrySelectorModal": "true",
          "caretIcon": "<svg id=\"caret_right_-_12\" data-name=\"caret right - 12\" xmlns=\"http://www.w3.org/2000/svg\" width=\"12\" height=\"12\" viewBox=\"0 0 12 12\"><title>ico-caret-right</title><path d=\"M3,12a.47.47,0,0,1-.35-.15.48.48,0,0,1,0-.7L7.79,6,2.65.85a.48.48,0,0,1,0-.7.48.48,0,0,1,.7,0l5.5,5.5a.48.48,0,0,1,0,.7l-5.5,5.5A.47.47,0,0,1,3,12Z\"/></svg>",
          "text": "继续",
          "style": "secondary-btn",
          "noResultText": "未找到结果",
          "csTitle": "选择其他国家或地区来查看特定于您所在位置的内容。",
          "modalCta": {
            "text": "继续",
            "style": "primary-btn"
          },
          "countries": {
            "item0": {
              "countryCode": "en-us",
              "countryName": "美国",
              "countryUrl": "/content/gehealthcare/us/en/home"
            },
            "item1": {
              "countryCode": "en-gb",
              "countryName": "英国",
              "countryUrl": "/content/gehealthcare/gb/en/home"
            },
            "item2": {
              "countryCode": "en-au",
              "countryName": "澳大利亚",
              "countryUrl": "/content/gehealthcare/au/en/home"
            },
            "item3": {
              "countryCode": "fr-fr",
              "countryName": "法国",
              "countryUrl": "/content/gehealthcare/fr/fr/home"
            },
            "item4": {
              "countryCode": "de-de",
              "countryName": "德国",
              "countryUrl": "/content/gehealthcare/de/de/home"
            },
            "item5": {
              "countryCode": "ko-kr",
              "countryName": "韩国",
              "countryUrl": "/content/gehealthcare/kr/ko/home"
            },
            "item6": {
              "countryCode": "ja-jp",
              "countryName": "日本",
              "countryUrl": "/content/gehealthcare/jp/ja/home"
            },
            "item7": {
              "countryCode": "en-ca",
              "countryName": "加拿大英语",
              "countryUrl": "/content/gehealthcare/ca/en/home"
            },
            "item8": {
              "countryCode": "fr-ca",
              "countryName": "加拿大法语",
              "countryUrl": "/content/gehealthcare/ca/fr/home"
            },
            "item9": {
              "countryCode": "ex-mx",
              "countryName": "墨西哥",
              "countryUrl": "/content/gehealthcare/mx/es/home"
            },
            "item10": {
              "countryCode": "pt-br",
              "countryName": "巴西",
              "countryUrl": "/content/gehealthcare/br/pt/home"
            },
            "item11": {
              "countryCode": "it-it",
              "countryName": "意大利",
              "countryUrl": "/content/gehealthcare/it/it/home"
            },
            "item12": {
              "countryCode": "es-es",
              "countryName": "西班牙",
              "countryUrl": "/content/gehealthcare/es/es/home"
            },
            "item13": {
              "countryCode": "tr-tr",
              "countryName": "火鸡",
              "countryUrl": "/content/gehealthcare/tr/tr/home"
            },
            "item14": {
              "countryCode": "en-in",
              "countryName": "印度",
              "countryUrl": "/content/gehealthcare/in/en/home"
            },
            "item15": {
              "countryCode": "en-sg",
              "countryName": "新加坡",
              "countryUrl": "/content/gehealthcare/sg/en/home"
            }
          }
        },
        "footerNavigationItems": {
          "item0": {
            "textLabel": "最新动态",
            "urlTarget": "_self",
            "path": "https://qa2.gehealthcare.cn/china-news"
          },
          "item1": {
            "textLabel": "招贤纳士",
            "urlTarget": "_blank",
            "path": "https://careers.gehealthcare.com/global/en"
          },
          "item2": {
            "textLabel": "联系我们",
            "urlTarget": "_self",
            "path": "https://qa2.gehealthcare.cn/about-gehc-china/contact-us"
          },
          "item3": {
            "textLabel": "招贤Test",
            "urlTarget": "_blank",
            "path": "https://qa2.gehealthcare.cn/about"
          }
        }
      }
    },
    {
      "footernavigation": {}
    }
  ]
};
export default data;
